import { useEffect, useRef } from 'react';

// binds a window keydown listener for ArrowLeft / ArrowRight (and optional Escape) for fullscreen image viewers (AccessImageCard, dashboard/DetectionDialog, archive/ArchiveContent)
// onPrev/onNext fire only when canPrev/canNext are truthy. Callbacks are read through a ref each fire so passing a freshly-allocated handler each render doesn't re-bind the listener (deps are only enabled/canPrev/canNext)
export function useArrowKeyNav({ enabled, canPrev, canNext, onPrev, onNext, onEscape }) {

    const handlersRef = useRef({})
    handlersRef.current = { onPrev, onNext, onEscape }

    useEffect(() => {
        if (!enabled) return
        const handler = (event) => {
            if (event.key === 'ArrowLeft' && canPrev) {
                handlersRef.current.onPrev?.()
            } else if (event.key === 'ArrowRight' && canNext) {
                handlersRef.current.onNext?.()
            } else if (event.key === 'Escape') {
                handlersRef.current.onEscape?.()
            }
        }
        window.addEventListener('keydown', handler)
        return () => window.removeEventListener('keydown', handler)
    }, [enabled, canPrev, canNext])
}
